export const AUI_VERSION = '10.5.3';
export const AUI_LAST_UPDATE = '2021-05-14T16:00:07.748Z';
